export default "__VITE_ASSET__$xk5Kq7E__"